import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {FavorittTjeneste} from "../../../../../../felles/tjenester/modulspesifikke/FavorittTjeneste";
import {OppgaveStatusOgNavn, OppgaveTjenesteWeb} from "../../../OppgaveTjenesteWeb";
import {OppgaveTjeneste} from "../../../../../../felles/tjenester/modulspesifikke/OppgaveTjeneste";
import {RedigerOppgaveDialog} from "../../../modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {OppgaveRessurs, OppgavestatusBeregnet} from "../../../../../../felles/tjenester/ressurser/OppgaveRessurs";
import {OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {KommentarDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import Oppgavestatus = l.Oppgavestatus;

require('./oppgave.scss');

export class OppgaveKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('woOppgave', {
              bindings: {oppgave: '<', oppdaterStatus: '&'},
              controller: OppgaveKontroller.forInjisering(),
              template: require('./oppgave.html')
          });
    }

    static forInjisering() {
        return [
            FavorittTjeneste.regNavn,
            OppgaveTjenesteWeb.regNavn,
            OppgaveTjeneste.regNavn,
            RedigerOppgaveDialog.regNavn,
            ng2RegNavn.KommentarDatatjenesteForAjs,
            OppgaveKontroller
        ]
    }

    constructor(private favorittTjeneste: FavorittTjeneste,
                private oppgaveTjenesteWeb: OppgaveTjenesteWeb,
                private oppgaveTjeneste: OppgaveTjeneste,
                private redigerOppgaveDialog: RedigerOppgaveDialog,
                private kommentarDatatjeneste: KommentarDatatjenesteForAjs) {
        this.muligeStatuser = this.oppgaveTjenesteWeb.muligeOppgavestatuser();
    }

    oppdaterStatus: (args: { spesifikasjon:l.OppgaveStatusSpesifikasjon }) => void;

    oppgave: l.OppgaveModell; //satt via bindings

    ng2Oppgave: OppgaveModell;
    muligeStatuser: OppgaveStatusOgNavn[];
    naavaerendeStatus: OppgaveStatusOgNavn;
    redigeringMulig = false;

    private heleBeskrivelsenVises = false;
    private kommentarerVises = false;

    visForelder() {
        // return this.oppgavelisteKontroller.visForelder !== 'false';
        return true;
    }

    oppgaveCssFargeklasse() {
        switch(this.naavaerendeStatus.status) {
            case Oppgavestatus.ikke_påbegynt: return "wo-o-status-velger-noytral";
            case Oppgavestatus.påbegynt: return "wo-o-status-velger-gul";
            case Oppgavestatus.utført: return "wo-o-status-velger-groenn";
            default: return ""
        }
    }

    erUtfort() {
        return this.naavaerendeStatus.status === l.Oppgavestatus.utført;
    }

    harStatus(status:l.Oppgavestatus) {
        return this.naavaerendeStatus.status === status;
    }

    statusEndret() {
        const spesifikasjon: l.OppgaveStatusSpesifikasjon = {
            id: this.oppgave.id,
            status: this.naavaerendeStatus.status,
            utfoertDato: this.naavaerendeStatus.status === Oppgavestatus.utført ? new Date() : null
        }
        this.oppdaterStatus({spesifikasjon: spesifikasjon});
    }

    oppgavestatus() {
        return OppgaveRessurs.oppgaveStatus2(this.oppgave);
    }

    oppgavestatusSomString() {
        return OppgaveRessurs.oppgaveStatus(this.oppgave);
    }

    oppgavestatuser() {
        return OppgavestatusBeregnet;
    }

    visEllerSkjulHeleBeskrivelsen() {
        this.heleBeskrivelsenVises = !this.heleBeskrivelsenVises;
    }

    rediger() {
        this.redigerOppgaveDialog.visRedigerOppgaveDialog(this.oppgave);
    }

    endreUtfoertStatus() {
        this.oppgaveTjenesteWeb.inverterUtførtStatus(this.oppgave)
          .then(oppdatert => this.oppgave = oppdatert);
    }

    slett() {
        this.oppgaveTjenesteWeb.slett(this.oppgave);
    }

    toggleVisKommentarer() {
        this.kommentarerVises = !this.kommentarerVises;
    }

    erVisKommentarer() {
        return this.kommentarerVises;
    }

    erFavoritt() {
        return this.favorittTjeneste.erFavoritt(this.oppgave);
    }

    endreFavorittmarkering() {
        this.favorittTjeneste.endreFavorittmarkeringForOppgave(this.oppgave);
    }

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'oppgave', () => {
            this.naavaerendeStatus = this.muligeStatuser.find(ms => ms.status === this.oppgave.status)
            this.redigeringMulig = this.oppgaveTjeneste.kanOppgaveRedigeres(this.oppgave);

            this.ng2Oppgave = kopierFraAjsTilNg2(this.oppgave);
            //populer KommentarerDatatjeneste (for at <kommentarer-teller> og <oppgave-kommentarer> skal ha tilgang til data)
            this.kommentarDatatjeneste.tjeneste().then(kommentarerDatatjeneste => {
                kommentarerDatatjeneste.erstattILokallager(this.ng2Oppgave.kommentarer, this.ng2Oppgave.id);
            });
        });
    }

    // hjelpemetoder

}
